import { MatPaginatorIntl } from '@angular/material/paginator';

export const paginatorIntlConfig = new MatPaginatorIntl();

paginatorIntlConfig.itemsPerPageLabel = 'Itens por página:';
paginatorIntlConfig.firstPageLabel = 'Primeira página';
paginatorIntlConfig.lastPageLabel = 'Última página';
paginatorIntlConfig.nextPageLabel = 'Próxima página';
paginatorIntlConfig.previousPageLabel = 'Página anterior';
paginatorIntlConfig.getRangeLabel = (page, size, length) => {
    const dataSize = (page + 1) * size;
    return `${page * size + 1} - ${dataSize > length ? length : dataSize} de ${length}`;
};
